import type { ReactNode } from 'react';
import { Header, SpaceBetween } from '@cloudscape-design/components';
import { PageLayout } from '@deloitte-us-consulting/gp-sdk';

/**
 * Lets a Data admin panel render either as a page of its own or inside a tab of
 * the unified Data page (ADR 0031, "Data systems"). Embedded, it drops the page
 * chrome and keeps the heading, description and actions as a section header.
 */
export function DataFrame({
  embedded = false,
  title,
  description,
  actions,
  children,
}: {
  embedded?: boolean | undefined;
  title: string;
  description?: string | undefined;
  actions?: ReactNode;
  children: ReactNode;
}) {
  if (!embedded) {
    return (
      <PageLayout title={title} {...(description ? { description } : {})} actions={actions}>
        {children}
      </PageLayout>
    );
  }
  return (
    <SpaceBetween size="l">
      <Header variant="h2" description={description} actions={actions}>
        {title}
      </Header>
      {children}
    </SpaceBetween>
  );
}
